/* ==========================================================================
   ModalLoading > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const ModalClient = require('../../../modal/client/js');
const LoadingInformationClient = require('../../../loading-information/client/js');
const prototype = require('./prototype');
const config = require('./config');

/**
 * ModalLoading component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function ModalLoading(selector = '[data-component="Modal"]', configuration = {}) {
    if (elementExist(selector)) {
        /* Instance to return */
        const instance = Object.create(prototype);

        /* Add the loading information reference */
        instance.loading = LoadingInformationClient(`${selector} [data-component="LoadingInformation"]`, {
            ...configuration.loading
        });

        /* Add the modal reference */
        instance.modal = ModalClient(`${selector}[data-type="${config().type.modal}"]`, {
            ...configuration.modal,
            type: config().type.modal,
            hasClose: false,
            isLoading: true
        });

        /* Return instance */
        return instance;
    }
};
